import React from 'react'
import PropTypes from 'prop-types'
import DatoImage from 'js/components/DatoRichText/DatoImage'
import cn from 'classnames'

export default function NumberedCardsBlock(props) {
  return (
    <div className="mx-auto flex max-w-480 flex-wrap items-start justify-center lg:max-w-none">
      {props.cards.map((card, index) => (
        <div
          key={card.id}
          className={cn(
            'mb-40 flex justify-between lg:mb-64 lg:px-40',
            props.imageOnTop ? 'flex-col' : 'flex-col-reverse',
            props.cards.length % 3 === 0 ? 'lg:w-1/3' : 'lg:w-1/2',
          )}
        >
          <div className="flex flex-col justify-center">
            <h2 className="mb-12 flex items-center type-24-bold">
              <span
                className="mt-4 inline-block shrink-0 rounded-full bg-green text-center font-demibold text-white type-24"
                style={{ width: '32px', height: '32px', lineHeight: '34px' }}
              >
                {index + 1}
              </span>
              <span className="ml-12">{card.heading}</span>
            </h2>
            <p className="type-18 mb-24">{card.body}</p>
          </div>
          <div
            className={cn('mx-auto mb-24 flex items-center justify-center', {
              'mb-24': props.imageOnTop,
            })}
            style={{ width: '70%' }}
          >
            <DatoImage
              src={card.image.url}
              alt=""
              className="mt-auto flex items-center justify-center"
              width={card.image.width}
              height={card.image.height}
              lazy
            />
          </div>
        </div>
      ))}
    </div>
  )
}

NumberedCardsBlock.propTypes = {
  cards: PropTypes.array,
  imageOnTop: PropTypes.bool,
}
